import { databaseVersion } from "./appDBConfig";

export const getAppConfig = (appConfigKey) =>
  Object.assign({}, appConfig[appConfigKey || "default"] || appConfig.default, {
    databaseVersion,
  });

const appConfig = {
  default: {
    subscriptionPage: "https://app.spectrebowling.com/registration",
    apiServer: "https://app.spectrebowling.com/api/",
    importServer: "https://app.spectrebowling.com/api/",
    fileServer: "https://app.spectrebowling.com/files/",
    appUrl: "https://app.spectrebowling.com/",
    resettingPage: "https://app.spectrebowling.com/resetting/request",
    commSocket: "wss://app.spectrebowling.com/comm",
  },
  "app.spectrebowling.com": {
    subscriptionPage: "https://app.spectrebowling.com/registration",
    apiServer: "https://app.spectrebowling.com/api/",
    importServer: "https://app.spectrebowling.com/api/",
    fileServer: "https://app.spectrebowling.com/files/",
    appUrl: "https://app.spectrebowling.com/",
    resettingPage: "https://app.spectrebowling.com/resetting/request",
    commSocket: "wss://app.spectrebowling.com/comm",
  },
  "local.spectrebowling.com": {
    subscriptionPage: "https://local.spectrebowling.com/registration",
    apiServer: "https://local.spectrebowling.com/api/",
    importServer: "https://local.spectrebowling.com/api/",
    fileServer: "https://local.spectrebowling.com/files/",
    appUrl: "https://local.spectrebowling.com/",
    resettingPage: "https://local.spectrebowling.com/resetting/request",
    commSocket: "wss://local.spectrebowling.com/comm",
  },
  localhost: {
    subscriptionPage: "https://dev.spectrebowling.com/registration",
    apiServer: "https://dev.spectrebowling.com/api/",
    importServer: "https://dev.spectrebowling.com/api/",
    fileServer: "https://dev.spectrebowling.com/files/",
    appUrl: "https://dev.spectrebowling.com/",
    resettingPage: "https://dev.spectrebowling.com/resetting/request",
    commSocket: "wss://dev.spectrebowling.com/comm",
  },
};
